export enum FACILITY_VERIFICATION_STAGE {
  APPROVED = 'APPROVED',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  REJECTED = 'REJECTED',
}

export interface IFacility {
  id?: number;
  st_id?: string;
  verification_stage?: FACILITY_VERIFICATION_STAGE;
  phoneNumber?: string;
  facilityName?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  //Types of anesthesia needed
  general_anesthesia?: boolean;
  ob_and_delivery?: boolean;
  dental?: boolean;
  ophthalmology?: boolean;
  pediatrics_one_year?: boolean;
  pediatrics_neonatal?: boolean;
  ent?: boolean;
  trauma?: boolean;
  orthopedic_regional?: boolean;
  neurosurgery?: boolean;
  cardiac?: boolean;
  transplant?: boolean;
  pain?: boolean;
  gastro_gi?: boolean;
  other?: boolean;
  other_string?: string;

  created_at?: Date;
  updated_at?: Date;
}

export interface IFacilityRoom {
  id?: number;
  facility_id?: number;
  name?: string;
  insuranceProvided?: boolean;
  equipmentProvided?: boolean;
  drugsProvided?: boolean;
  notes?: string;
  doctors?: string;
  created_at?: Date;
  updated_at?: Date;
}
